import { FC } from "react";

import { SectionScoreDashboardDataType } from "./hooks";

import { displayOutcomeName } from "components/outcomes/helpers";
import { ScrollableTableContainer } from "components/tables/ScrollableTableContainer";
import { TD, TH, THead, TR, Table } from "components/tables/TableElements";
import { t } from "i18n/i18n";
import { ScoreIcon } from "mds/icons";
import { NestedSectionOutcomeType } from "store/selectors/types";

type OutcomeScoreTableProps = {
  studentScoresPerOutcomeCSVData: SectionScoreDashboardDataType["studentScoresPerOutcomeCSVData"];
  studentScoresPerOutcomeTableRows: SectionScoreDashboardDataType["studentScoresPerOutcomeTableRows"];
  sectionOutcomes: NestedSectionOutcomeType[];
};

export const OutcomeScoreTable: FC<OutcomeScoreTableProps> = ({
  studentScoresPerOutcomeCSVData,
  studentScoresPerOutcomeTableRows,
  sectionOutcomes,
}) => {
  if (studentScoresPerOutcomeTableRows.length === 0 || sectionOutcomes.length === 0) {
    return null;
  }

  return (
    <ScrollableTableContainer
      exportData={studentScoresPerOutcomeCSVData}
      title={t("assessment_dashboard.student_score_per_outcome_title")}
      titleTooltipText={t("assessment_dashboard.student_score_per_outcome_tooltip")}
    >
      <Table>
        {/* Headers: <blank> / Outcome A / Outcome B / Outcome C */}
        {/* One row per student, showing each student's aggregate outcome scores */}
        <THead>
          <TR className="border-black-tint-70">
            <TH className="w-6/12 pl-4">
              {t("assessment_dashboard.all.student_name_header_title")}
            </TH>

            {sectionOutcomes.map((sectionOutcome) => (
              <TH
                key={sectionOutcome.id}
                verticalDivClassName="max-h-[180px]"
                verticalDivTitle={displayOutcomeName(sectionOutcome.outcome)}
                isVertical
              >
                {displayOutcomeName(sectionOutcome.outcome)}
              </TH>
            ))}
          </TR>
        </THead>

        <tbody>
          {studentScoresPerOutcomeTableRows.map((row) => (
            <TR key={row.student.user_id}>
              <TD className="max-w-40 truncate py-2.5 pl-[17px]" title={row.studentName}>
                {row.studentName}
              </TD>

              {row.outcomeScores.map((score, index) => (
                <TD key={sectionOutcomes[index].id}>
                  <ScoreIcon value={score ?? NaN} />
                </TD>
              ))}
            </TR>
          ))}
        </tbody>
      </Table>
    </ScrollableTableContainer>
  );
};
